/* =========================================================
   VIVA Cosmética · Tema Shopify — comportamento
   ========================================================= */
(function(){
  var raiz=document.documentElement;
  raiz.classList.add('js');
  var reduzido=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduzido) raiz.classList.add('reduzido');

  /* ---------- Barra de anúncio ---------- */
  var anuncioMais=document.getElementById('anuncioMais');
  var anuncioDetalhe=document.getElementById('anuncioDetalhe');
  if(anuncioMais && anuncioDetalhe){
    anuncioMais.addEventListener('click',function(){
      var aberto=anuncioDetalhe.classList.toggle('aberto');
      anuncioMais.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      anuncioMais.textContent=aberto ? 'fechar' : 'saiba mais';
    });
  }

  /* ---------- Navegação: sombra + mega por toque ---------- */
  var nav=document.querySelector('.nav');
  var itensMenu=[].slice.call(document.querySelectorAll('.menu > li'));
  var soToque=window.matchMedia('(hover: none)').matches;
  itensMenu.forEach(function(li){
    var mega=li.querySelector('.mega'); if(!mega) return;
    var topo=li.querySelector('.menu-topo');
    topo.addEventListener('click',function(e){
      if(!soToque) return;
      if(getComputedStyle(mega).display==='none') return;
      if(!li.classList.contains('aberto')){
        e.preventDefault();
        itensMenu.forEach(function(o){ o.classList.remove('aberto'); });
        li.classList.add('aberto');
      }
    });
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest('.menu')){
      itensMenu.forEach(function(o){ o.classList.remove('aberto'); });
    }
  });

  /* ---------- Hero: efeito de encolher + parallax ---------- */
  var flutuantes=[].slice.call(document.querySelectorAll('[data-flutua]'));
  var heroEnvolve=document.querySelector('.hero-envolve');
  var heroMiolo=document.querySelector('.hero-miolo');
  var heroFixo=document.querySelector('.hero-slider');
  var aPedir=false;

  function quadro(){
    aPedir=false;
    var y=window.scrollY||0;
    if(nav) nav.classList.toggle('rolada', y>8);
    if(reduzido) return;

    if(heroEnvolve && heroMiolo && heroFixo){
      var total=heroEnvolve.offsetHeight-heroFixo.offsetHeight;
      var r=heroEnvolve.getBoundingClientRect();
      var p=total>0 ? Math.min(1,Math.max(0,-r.top/total)) : 0;
      heroMiolo.style.transform='scale('+(1-p*0.1)+') translateY('+(p*-38)+'px)';
      heroMiolo.style.opacity=String(Math.max(0,1-p));
      heroMiolo.style.pointerEvents = p>0.75 ? 'none' : '';
    }

    var vh=window.innerHeight;
    for(var i=0;i<flutuantes.length;i++){
      var el=flutuantes[i];
      var caixa=(el.parentElement||el).getBoundingClientRect();
      var centro=caixa.top+caixa.height/2-vh/2;
      var vel=parseFloat(el.getAttribute('data-flutua'))||0;
      el.style.transform='translateY('+(centro*-vel).toFixed(1)+'px)';
    }
  }
  function aoRolar(){ if(!aPedir){ aPedir=true; requestAnimationFrame(quadro); } }
  window.addEventListener('scroll',aoRolar,{passive:true});
  window.addEventListener('resize',aoRolar);
  quadro();

  /* ---------- Hero deslizante ---------- */
  var heroSlides=[].slice.call(document.querySelectorAll('.hslide'));
  var heroTabs=[].slice.call(document.querySelectorAll('.hero-tab'));
  if(heroSlides.length){
    var heroAtual=0, heroTimer=null, heroHover=false, heroFoco=false;
    var heroMs=parseInt((heroFixo && heroFixo.getAttribute('data-intervalo'))||'6000',10);
    var mostraHero=function(i){
      heroAtual=i;
      heroSlides.forEach(function(s,j){
        s.classList.toggle('ativo', j===i);
        s.setAttribute('aria-hidden', j===i ? 'false' : 'true');
      });
      heroTabs.forEach(function(t,j){
        t.classList.toggle('ativo', j===i);
        if(j===i){ t.setAttribute('aria-current','true'); } else { t.removeAttribute('aria-current'); }
      });
    };
    var agendaHero=function(){
      clearInterval(heroTimer);
      if(reduzido || heroSlides.length<2 || heroHover || heroFoco) return;
      heroTimer=setInterval(function(){ mostraHero((heroAtual+1)%heroSlides.length); },heroMs);
    };
    heroTabs.forEach(function(t,i){
      t.addEventListener('click',function(){ mostraHero(i); });
    });
    if(heroFixo){
      heroFixo.addEventListener('mouseenter',function(){ heroHover=true; clearInterval(heroTimer); });
      heroFixo.addEventListener('mouseleave',function(){ heroHover=false; agendaHero(); });
      heroFixo.addEventListener('focusin',function(){ heroFoco=true; clearInterval(heroTimer); });
      heroFixo.addEventListener('focusout',function(){ heroFoco=false; agendaHero(); });
    }
    mostraHero(0);
    agendaHero();
  }

  /* ---------- Montras rotativas (slides renderizados em Liquid) ---------- */
  [].slice.call(document.querySelectorAll('[data-montra]')).forEach(function(zona){
    var slides=[].slice.call(zona.querySelectorAll('.montra-slide'));
    if(!slides.length){ zona.hidden=true; return }
    var botoes=[];
    if(slides.length>1){
      var pontos=document.createElement('div'); pontos.className='montra-pontos';
      slides.forEach(function(_,i){
        var b=document.createElement('button'); b.type='button';
        b.className='montra-ponto'+(i===0?' ativo':'');
        b.setAttribute('aria-label','Mostrar produto '+(i+1));
        if(i===0){ b.setAttribute('aria-current','true'); }
        b.addEventListener('click',function(){ mostra(i); });
        pontos.appendChild(b); botoes.push(b);
      });
      zona.appendChild(pontos);
    }
    var atual=0, timer=null, emHover=false, comFoco=false;
    function mostra(i){
      atual=i;
      slides.forEach(function(s,j){
        s.classList.toggle('ativo', j===i);
        s.setAttribute('aria-hidden', j===i ? 'false' : 'true');
      });
      botoes.forEach(function(b,j){
        b.classList.toggle('ativo', j===i);
        if(j===i){ b.setAttribute('aria-current','true'); } else { b.removeAttribute('aria-current'); }
      });
    }
    function agenda(){
      clearInterval(timer);
      if(reduzido || slides.length<2 || emHover || comFoco) return;
      timer=setInterval(function(){ mostra((atual+1)%slides.length); },5000);
    }
    zona.addEventListener('mouseenter',function(){ emHover=true; clearInterval(timer); });
    zona.addEventListener('mouseleave',function(){ emHover=false; agenda(); });
    zona.addEventListener('focusin',function(){ comFoco=true; clearInterval(timer); });
    zona.addEventListener('focusout',function(){ comFoco=false; agenda(); });
    agenda();
  });

  /* ---------- Revelações no scroll ---------- */
  var revelaveis=[].slice.call(document.querySelectorAll('[data-rev]'));
  var manifesto=document.querySelector('.manifesto h2');
  if(manifesto){
    (function dividir(no){
      var filhos=[].slice.call(no.childNodes);
      filhos.forEach(function(f){
        if(f.nodeType===3){
          var pedacos=f.textContent.split(/(\s+)/);
          var frag=document.createDocumentFragment();
          pedacos.forEach(function(t){
            if(/^\s+$/.test(t)||t===''){ frag.appendChild(document.createTextNode(t)); }
            else{
              var s=document.createElement('span');
              s.className='p'; s.textContent=t;
              frag.appendChild(s);
            }
          });
          no.replaceChild(frag,f);
        } else if(f.nodeType===1){ dividir(f); }
      });
    })(manifesto);
    [].slice.call(manifesto.querySelectorAll('.p')).forEach(function(s,i){
      s.style.setProperty('--atraso',(i*38)+'ms');
    });
  }
  if('IntersectionObserver' in window && !reduzido){
    var obs=new IntersectionObserver(function(entradas){
      entradas.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    },{threshold:0.18, rootMargin:'0px 0px -6% 0px'});
    revelaveis.forEach(function(el){ obs.observe(el); });
    if(manifesto) obs.observe(manifesto);
  } else {
    revelaveis.forEach(function(el){ el.classList.add('is-in'); });
    if(manifesto) manifesto.classList.add('is-in');
  }

  /* ---------- Séruns por objetivo ---------- */
  var caixaResposta=document.getElementById('objetivoResposta');
  if(caixaResposta){
    [].slice.call(document.querySelectorAll('.objetivo')).forEach(function(b){
      b.addEventListener('click',function(){
        document.querySelectorAll('.objetivo').forEach(function(o){ o.classList.remove('ativo'); });
        b.classList.add('ativo');
        var ativo=b.getAttribute('data-ativo')||'';
        var texto=b.getAttribute('data-resposta')||'';
        caixaResposta.innerHTML='';
        if(ativo){
          var f=document.createElement('strong'); f.textContent=ativo;
          caixaResposta.appendChild(f);
          caixaResposta.appendChild(document.createTextNode(' — '+texto));
        } else {
          caixaResposta.textContent=texto;
        }
      });
    });
  }

  /* ---------- Coleção: ordenar ---------- */
  var ordenar=document.getElementById('ordenarColecao');
  if(ordenar){
    ordenar.addEventListener('change',function(){
      var url=new URL(window.location.href);
      url.searchParams.set('sort_by',ordenar.value);
      url.searchParams.delete('page');
      window.location.href=url.toString();
    });
  }

  /* ---------- Filtros de listagem (coleção e pesquisa) ---------- */
  [].slice.call(document.querySelectorAll('select[data-liga]')).forEach(function(sel){
    var parametro=sel.getAttribute('data-parametro');
    if(parametro){
      var urlInicial=new URL(window.location.href);
      var valorAtivo=urlInicial.searchParams.get(parametro);
      if(valorAtivo){ sel.value=valorAtivo; }
      sel.addEventListener('change',function(){
        var url=new URL(window.location.href);
        if(sel.value){ url.searchParams.set(parametro,sel.value); }
        else{ url.searchParams.delete(parametro); }
        url.searchParams.delete('page');
        window.location.href=url.toString();
      });
    } else {
      sel.addEventListener('change',function(){
        if(sel.value){ window.location.href=sel.value; }
      });
    }
  });

  /* ---------- Produto: quantidade ---------- */
  [].slice.call(document.querySelectorAll('.quantidade')).forEach(function(q){
    var campo=q.querySelector('input');
    var menos=q.querySelector('[data-menos]');
    var mais=q.querySelector('[data-mais]');
    if(!campo) return;
    if(menos) menos.addEventListener('click',function(){
      var v=parseInt(campo.value,10)||1; if(v>1){ campo.value=String(v-1); campo.dispatchEvent(new Event('change')); }
    });
    if(mais) mais.addEventListener('click',function(){
      var v=parseInt(campo.value,10)||1; campo.value=String(v+1); campo.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- Produto: variantes ---------- */
  var formProduto=document.querySelector('[data-form-produto]');
  if(formProduto){
    var dadosEl=document.getElementById('dadosVariantes');
    var variantes=[];
    try{ variantes=JSON.parse(dadosEl.textContent); }catch(e){}
    var selects=[].slice.call(formProduto.querySelectorAll('.p-opcao select'));
    var campoId=formProduto.querySelector('input[name="id"]');
    var elPreco=document.querySelector('[data-preco]');
    var elAntes=document.querySelector('[data-preco-antes]');
    var elSelo=document.querySelector('[data-selo]');
    var elStock=document.querySelector('[data-stock]');
    var botao=formProduto.querySelector('.btn-cesto');
    function moeda(cent){
      return (cent/100).toFixed(2).replace('.',',')+' €';
    }
    function atualiza(){
      if(!variantes.length || !selects.length) return;
      var escolha=selects.map(function(s){ return s.value });
      var v=null;
      for(var i=0;i<variantes.length;i++){
        var ok=true;
        for(var j=0;j<escolha.length;j++){
          if(variantes[i].options[j]!==escolha[j]){ ok=false; break }
        }
        if(ok){ v=variantes[i]; break }
      }
      if(!v){
        if(botao){
          botao.disabled=true;
          var rotuloInd=botao.querySelector('[data-rotulo]');
          if(rotuloInd) rotuloInd.textContent='Indisponível';
        }
        return;
      }
      if(campoId) campoId.value=v.id;
      if(elPreco) elPreco.textContent=moeda(v.price);
      var promo=v.compare_at_price && v.compare_at_price>v.price;
      if(elAntes){ elAntes.hidden=!promo; if(promo) elAntes.textContent=moeda(v.compare_at_price); }
      if(elSelo){ elSelo.hidden=!promo; if(promo) elSelo.textContent='Poupa '+Math.round((1-v.price/v.compare_at_price)*100)+'%'; }
      if(elStock){
        elStock.classList.toggle('esgotado', !v.available);
        var etiqueta=elStock.querySelector('span');
        if(etiqueta) etiqueta.textContent=v.available ? 'Disponível · expedição em 24–48h úteis' : 'Esgotado';
      }
      if(botao){
        botao.disabled=!v.available;
        var rotulo=botao.querySelector('[data-rotulo]');
        if(rotulo) rotulo.textContent=v.available ? 'Adicionar ao cesto' : 'Esgotado';
      }
      if(history.replaceState){
        var url=new URL(window.location.href);
        url.searchParams.set('variant',v.id);
        history.replaceState(null,'',url.toString());
      }
    }
    selects.forEach(function(s){ s.addEventListener('change',atualiza); });
  }

  /* ---------- Selects com valor guardado (ex.: país da morada) ---------- */
  [].slice.call(document.querySelectorAll('select[data-default]')).forEach(function(s){
    var d=s.getAttribute('data-default');
    if(!d) return;
    for(var i=0;i<s.options.length;i++){
      if(s.options[i].text===d || s.options[i].value===d){ s.selectedIndex=i; break }
    }
  });

  /* ---------- Produto: galeria ---------- */
  var galeriaPrincipal=document.querySelector('.galeria-principal img');
  if(galeriaPrincipal){
    [].slice.call(document.querySelectorAll('.galeria-mini')).forEach(function(mini){
      mini.addEventListener('click',function(){
        var src=mini.getAttribute('data-imagem');
        if(src){
          galeriaPrincipal.removeAttribute('srcset');
          galeriaPrincipal.removeAttribute('sizes');
          galeriaPrincipal.src=src;
        }
        document.querySelectorAll('.galeria-mini').forEach(function(o){ o.classList.remove('ativo'); });
        mini.classList.add('ativo');
      });
    });
  }
})();
